var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"image",attrs:{"href":_vm.url,"target":"_blank","rel":"noreferrer noopener nofollow"}},[_c('div',{staticClass:"wrap"},[_c('img',{attrs:{"src":_vm.thumb,"alt":"Picture message"},on:{"click":_vm.onClick,"error":_vm.onImgError}}),_vm._v(" "),_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.readableTime))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }